module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABVElEQVRYR+2YT2qEMBTGXyS6U+lGxK1Qc4QeYE7QnqYn6GnaE/QAPYIW3IkgKGVGcGEiKdmUcRz/JFMhtAm4Mu+9X74vap4INBtIMx4wQGuOXFUoz/N7xtgL5/wAAN5aEsn7J4TQO8b4OY7jz8vYCZCAoZR+AMCdZCHZ6V+2bT9cQk2Asix75Zw/ymZXmY8QekuS5Ok8dgKUpulxB5vmeE+EEH8NiKusVjWGEDIS5ZpCBkjJMsdxIAgCwBgvukMphaqqgDG2yUVly8IwBN8f7b/ZgnVdQ9M0+wJ5ngcCCqHlrw3nHIqigK7r9gUS2YVdlmUtFhqGAcS1dShbtrWA7DwDtKaYUej/KOS6Loi39S2j73to23aUQmkPCZgoim5h+Ykty3IE9TeAxPK0suxXvJpJomSZATpXQLtDvnZtkHaNorBPq1Z6zydqS27zO2ZNJe0U+gbwSMwljVQ59wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boss-underStudent/staff-task.png
// module id = Djrd
// module chunks = 1